import { h } from 'preact';
import { useEffect, useMemo } from 'preact/hooks';

import Store from '../../stores/Store';
import { Route, route } from 'preact-router';
const RouteRedirectUrl = props => {
  const store = useMemo(() => new Store(), []);

  useEffect(() => {
    if (props.to) {
      const token = store.get('token');
      let url = '';
      if (props.to.includes('?')) {
        url = `${props.to}&token=${token}`;
      } else {
        url = `${props.to}?token=${token}`;
      }
      setTimeout(() => {
        const a = document.createElement('a');
        a.href = url;
        // a.target = '_self';
        a.click();
      }, 500);
      // location.reload();
    }
  }, []);

  return null;
};

export default RouteRedirectUrl;
